import { Link } from "react-router-dom";
import "../../assets/css/course.css";
import Rating from "../sidebar/rating";

const subTitle = "Featured Courses";
const title = "Pick A Course To Get Started";


const courseList = [
    {
        imgUrl: 'assets/images/course/01.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        title: 'Introdution to Arduino',
        description: 'Learn the basics of Arduino programming and electronics through hands-on projects',
        totalLeson: '12+ Session',
        ageRange: 'Ages 12+',
        authorImgUrl: 'assets/images/course/author/01.jpg',
        authorImgAlt: 'course author rajibraj91 rajibraj',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/02.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        title: 'Coding languages',
        description: 'Master fundamental programming concepts and popular coding languages',
        totalLeson: '12+ Lesson',
        ageRange: 'Ages 12+',
        authorImgUrl: 'assets/images/course/author/02.jpg',
        authorImgAlt: 'course author rajibraj91 rajibraj',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/03.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        title: 'School companion',
        description: 'Get help with your school subjects and homework from expert tutors',
        totalLeson: '12+ Lesson',
        ageRange: 'Ages 10+',
        authorImgUrl: 'assets/images/course/author/03.jpg',
        authorImgAlt: 'course author rajibraj91 rajibraj',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/04.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        title: 'LEGO services',
        description: 'Explore creativity and problem-solving through LEGO building and programming',
        totalLeson: '12+ Lesson',
        ageRange: 'Ages 7-11',
        authorImgUrl: 'assets/images/course/author/04.jpg',
        authorImgAlt: 'course author rajibraj91 rajibraj',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/05.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        title: 'Design Services',
        description: 'Learn graphic design, 3D modeling, and digital art creation',
        totalLeson: '12+ Lesson',
        ageRange: 'Ages 15-18',
        authorImgUrl: 'assets/images/course/author/05.jpg',
        authorImgAlt: 'course author rajibraj91 rajibraj',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/06.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        title: 'Block programming',
        description: 'Start your coding journey with visual block-based programming',
        totalLeson: '12+ Lesson',
        ageRange: 'Ages 5+',
        authorImgUrl: 'assets/images/course/author/06.jpg',
        authorImgAlt: 'course author rajibraj91 rajibraj',
        btnText: 'Read More',
    },
]

const Course = () => {
    return (
        <div className="course-section padding-tb section-bg">
            <div className="container">
                <div className="section-header text-center">
                    <span className="subtitle">{subTitle}</span>
                    <h2 className="title">{title}</h2>
                </div>
                <div className="section-wrapper">
                    <div className="row g-4 justify-content-center row-cols-xl-3 row-cols-md-2 row-cols-1">
                        {courseList.map((val, i) => (
                            <div className="col" key={i}>
                                <div className="course-item">
                                    <div className="course-inner">
                                        <div className="course-thumb">
                                            <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                            {/* <div className="course-price">{val.price}</div> */}
                                        </div>
                                        <div className="course-content">
                                            {/* <div className="course-category">
                                                <span className="course-cate">{val.cate}</span>
                                            </div> */}
                                            <Link to="/course-single">
                                                <h4>{val.title}</h4>
                                            </Link>
                                            <p className="course-description">{val.description}</p>
                                            <div className="course-details">
                                                <div className="course-count">
                                                    <i className="icofont-video-alt"></i> {val.totalLeson}
                                                </div>
                                                <div className="course-topic">
                                                    <i className="icofont-user"></i> {val.ageRange}
                                                </div>
                                            </div>
                                            <div className="course-btn">
                                                <Link to="/course-single" className="lab-btn-text">
                                                    Book Now
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Course;